import { put, takeLatest, call } from 'typed-redux-saga/macro';
import { questionnairesActionTypes } from '../ducks/questionnaires';
import { memberApiV2 } from '../../lib/api';

function* getQuestionnairesRequest({ payload }: any) {
  try {
    yield put({
      type: questionnairesActionTypes.GET_QUESTIONNAIRES_SUCCESS,
      payload: [],
    });
    const questionnairesReq: any = yield* call(
      memberApiV2.getQuestionnaires,
      payload.providerId,
      payload.id,
    );
    yield put({
      type: questionnairesActionTypes.GET_QUESTIONNAIRES_SUCCESS,
      payload: questionnairesReq.data.data,
    });
  } catch {}
}

function* questionnairesSaga() {
  yield takeLatest(questionnairesActionTypes.GET_QUESTIONNAIRES_REQUEST, getQuestionnairesRequest);
}

export default questionnairesSaga;
